import { Injectable } from '@angular/core';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { AlertController, Platform } from '@ionic/angular';
import { Market } from '@ionic-native/market/ngx';
import { ApiService } from "../http/api.service";
import { ApiConfiguration } from "../http/api-configuration";

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  version;
  appInfo: any = {}
  constructor(
    private alertController: AlertController,
    private appVersion: AppVersion,
    private plt: Platform,
    private market: Market,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
  ) { }

  async descideUpdateAction() {
    this.version = await this.appVersion.getVersionNumber();
    this.apiService.get(this.apiConfig.getAppInfo)
      .subscribe((res: any) => {
        this.appInfo = res.data.app_info[0]
        if (this.plt.is('android')) {
          //current_version
          if (parseFloat(this.appInfo.current_android_version) > parseFloat(this.version))
            return this.majorUpdate();
        } else {
          if (parseFloat(this.appInfo.current_ios_version) > parseFloat(this.version))
            return this.majorUpdate();
        }
      }, err => {
        console.log(err)
      });
  }

  async majorUpdate() {
    const alert = await this.alertController.create({
      cssClass: 'cargill-alert t2',
      subHeader: `There is a Majour update in our app. Please update to continue`,
      buttons: ['Update'],

      backdropDismiss: false
    });

    await alert.present();

    await alert.onDidDismiss().then(() => this.updateBlock());
  }

  updateBlock() {
    console.log(this.appInfo)
    if (this.plt.is('android')) {
      this.market.open(this.appInfo.android_address);
    } else {
      console.log('IOS');
      this.market.open(this.appInfo.ios_address);
    }
  }

}